import React from 'react';

// Approved exception to the inline-styles-only rule (2026-10-09): inline styles can't
// target :focus-visible, so this single global rule gives every link, button and other
// focusable element a keyboard focus ring. Mounted once, in index.tsx.
const FOCUS_RING_CSS = ':focus-visible{outline:2px solid #185FA5;outline-offset:2px}';

const FocusRing = () => <style>{FOCUS_RING_CSS}</style>;

export default FocusRing;
